import { render } from "./AuthNavbar.vue?vue&type=template&id=a80c2180&ts=true"
import script from "./AuthNavbar.vue?vue&type=script&lang=ts"
export * from "./AuthNavbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__